'use client';

import { Suspense } from 'react';
import { LobbyClient } from '@/features/lobby/LobbyClient';
import { LaunchTransitionProvider } from '@/features/lobby/launch/LaunchTransitionProvider';
import { ExternalLinkGuardProvider } from '@/features/lobby/ui/ExternalLinkGuard';
import { TutorialProviders } from '@/features/tutorial/TutorialProviders';

/**
 * Tutorial layout — mounts the real `LobbyClient` against the tutorial
 * sandbox so every panel, drawer, and canvas renders identically to the
 * live app, but every data source short-circuits to `TutorialContext`.
 *
 * Lives outside the `(lobby)` route group so its providers don't bleed
 * into other routes and its layout chrome stays isolated.
 */
export default function TutorialLayout({ children }: { children: React.ReactNode }) {
  return (
    <LaunchTransitionProvider>
      <ExternalLinkGuardProvider>
        <TutorialProviders>
          <Suspense fallback={null}>
            <LobbyClient />
          </Suspense>
          {children}
        </TutorialProviders>
      </ExternalLinkGuardProvider>
    </LaunchTransitionProvider>
  );
}
